import { Link } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

function FooterNavListWrapper({ children }: { children: React.ReactNode }) {
	return <div className="flex flex-col gap-1 md:mr-10">{children}</div>
}
function FooterNavHeading({
	children,
	className,
	link,
}: {
	children: React.ReactNode
	className?: string
	link?: string
}) {
	return (
		<h3
			className={cn(
				'mb-2 text-sm font-medium md:text-[11.2px]',
				className
			)}
		>
			{link ? (
				<Link to={link} target="_blank" className="text-black">
					{children}
				</Link>
			) : (
				children
			)}
		</h3>
	)
}
function FooterNavList({ children }: { children: React.ReactNode }) {
	return <ul className="flex flex-col gap-0">{children}</ul>
}

function FooterNavListItemLink({
	children,
	href = '/',
	isExternal = false,
	isHeader = false,
}: {
	isExternal?: boolean
	href: string
	children: React.ReactNode
	isHeader?: boolean
}) {
	return (
		<>
			{!isExternal && (
				<li className="text-[10.5px] md:text-[9.6px] text-black">
					<Link to={href}>{children}</Link>
				</li>
			)}
			{isExternal && (
				<li>
					<Link
						className={cn(
							'inline-block w-full py-1 text-[10.5px] md:text-[9.6px] text-black',
							isHeader && 'text-sm font-medium md:text-[11.2px]'
						)}
						to={href}
						target="_blank"
					>
						{children}{' '}
					</Link>
				</li>
			)}
		</>
	)
}

export {
	FooterNavListWrapper,
	FooterNavHeading,
	FooterNavList,
	FooterNavListItemLink,
}
